import React from "react";
import { Link } from "react-router-dom";
import CommonButton from "../CommonButton";
import { useSelector } from "react-redux";
import LoaderButton from "../LoaderButton";

const GpsCommonModal = ({
  isOpen,
  closeModal,
  modalTitle = "",
  submitTitle = "Submit",
  cancleTitle = "",
  children,
  isLoadding = false,
  onSubmit,
  disabled = false,
  modalMainClass,
  headerPart = false,
  footerPart = false,
  modalZIndex,
  cancelButtonTitle = "Cancel",
  sendFor,
  isDivForth = false,
  continueOnClick,
  saveOnClick,
  resetButtonTitle,
  resetButtonClick,
  hideFooterSumbmitBtn = false,
  isLoaddingforsave,
  show = "show",
  hideCompletelyFoolter = false,
  newSubmitTitle='',
  userSettingPermission="",
  secondSubmit,
  isAddLrLater=false,
  therdSubmitTitle,
  onPrint=()=>{},
  isLoaddingPrint=false
}) => {
  const { loading, error, data } = useSelector((state) => state.auth);

  return (
    <div>
      {isOpen && (
        <div
          id="myModal"
          className={`modal fade ${show} d-block  ${modalMainClass}`}
          tabIndex="-1"
          role="dialog"
          style={{ zIndex: modalZIndex }}
        >
          <div className="modal-dialog modal-dialog-centered">
            <div
              className="modal-content"
              style={{ display: modalZIndex == -1 ? "none" : "" }}
            >
              {headerPart ? (
                <div className="modal-header">
                  <h3 className="modal-title _cmmTitle">{modalTitle}</h3>
                </div>
              ) : (
                <div className="modal-header">
                  <span>{modalTitle}</span>

                  <button className="_switchBtn" onClick={closeModal}>
                    
                      <svg
                        className="cross"
                        xmlns="http://www.w3.org/2000/svg"
                        width="13"
                        height="13"
                        viewBox="0 0 13 13"
                        fill="none"
                      >
                        <path
                          d="M12.5321 0.477671C12.4422 0.387555 12.3353 0.316061 12.2177 0.267281C12.1001 0.2185 11.9741 0.193391 11.8468 0.193391C11.7195 0.193391 11.5934 0.2185 11.4758 0.267281C11.3582 0.316061 11.2514 0.387555 11.1615 0.477671L6.40798 5.22143L1.6545 0.46795C1.56451 0.377952 1.45766 0.306563 1.34008 0.257857C1.22249 0.20915 1.09646 0.184082 0.969185 0.184082C0.84191 0.184082 0.715881 0.20915 0.598294 0.257857C0.480707 0.306563 0.373865 0.377952 0.283868 0.46795C0.19387 0.557947 0.122481 0.664789 0.0737746 0.782376C0.0250685 0.899963 -9.48274e-10 1.02599 0 1.15327C9.48275e-10 1.28054 0.0250684 1.40657 0.0737746 1.52416C0.122481 1.64175 0.19387 1.74859 0.283868 1.83858L5.03735 6.59206L0.283868 11.3455C0.19387 11.4355 0.122481 11.5424 0.0737746 11.66C0.0250685 11.7776 0 11.9036 0 12.0309C0 12.1581 0.0250685 12.2842 0.0737746 12.4017C0.122481 12.5193 0.19387 12.6262 0.283868 12.7162C0.373865 12.8062 0.480707 12.8776 0.598294 12.9263C0.715881 12.975 0.84191 13 0.969185 13C1.09646 13 1.22249 12.975 1.34008 12.9263C1.45766 12.8776 1.56451 12.8062 1.6545 12.7162L6.40798 7.9627L11.1615 12.7162C11.2515 12.8062 11.3583 12.8776 11.4759 12.9263C11.5935 12.975 11.7195 13 11.8468 13C11.974 13 12.1001 12.975 12.2177 12.9263C12.3353 12.8776 12.4421 12.8062 12.5321 12.7162C12.6221 12.6262 12.6935 12.5193 12.7422 12.4017C12.7909 12.2842 12.816 12.1581 12.816 12.0309C12.816 11.9036 12.7909 11.7776 12.7422 11.66C12.6935 11.5424 12.6221 11.4355 12.5321 11.3455L7.77861 6.59206L12.5321 1.83858C12.9015 1.46919 12.9015 0.847062 12.5321 0.477671Z"
                          fill="black"
                        />
                      </svg>
                    
                  </button>
                </div>
              )}

              {children}
             {!isOpen?.view && <>
                <div
                      className="modal-footer"
                      style={{ zIndex: modalZIndex }}
                    >

                      <LoaderButton
                        onClick={onSubmit}
                        isLoading={isLoaddingforsave} // Loading state for Approval button
                        isLoadingText="Processing..."
                        className="_addComm_btn"
                        disabled={isLoaddingforsave}
                      >
                        {isLoaddingforsave ? "Processing..." : submitTitle}
                      </LoaderButton>
                      <LoaderButton
                        onClick={sendFor}
                        isLoading={isLoadding} // Loading state for Approval button
                        isLoadingText="Processing..."
                        className="_addComm_btn"
                        disabled={isLoadding}
                      >
                        {isLoadding ? "Processing..." : cancelButtonTitle}
                      </LoaderButton>
                    </div>
              </>}
             
            </div>
          </div>
        </div>
      )}
      {isOpen && (
        <div
          className={
            modalZIndex
              ? "modal-backdrop fade show"
              : "modal-backdrop fade show"
          }
          style={{ zIndex: modalZIndex ? 99 : "" }}
          onClick={closeModal}
        ></div>
      )}
    </div>
  );
};

export default GpsCommonModal;
